export const selectDataMarketplaceFeeds = (feeds) => {
  if (feeds?.length > 0) {
    const dataMarketplaceFeeds = feeds.map((feed) => {
      return { label: feed.display_name, value: feed.uuid };
    });

    return dataMarketplaceFeeds;
  } else {
    return null;
  }
};
